import InputMask, { ReactInputMask } from 'react-input-mask';

function BirthDateMask(props: Readonly<ReactInputMask>) {
  return <InputMask mask="99/99/9999" {...props} />;
}

export default BirthDateMask;
